<script setup>
/**
 * FormControlTemplatesTemplatesCssGroupName
 * A dropdown select for choosing a CSS group name.
 * It fetches available CSS group names from the themes_css component API endpoint
 * and populates the dropdown with unique, sorted group names.
 */
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import formValidation from '../../vue/directives/formValidation';

// Register the local directive for use in the template
const vFormValidation = formValidation;

const { proxy } = getCurrentInstance();
const store = proxy.$store;

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
});

const components = ref([]);

const options = computed(() => {
    if (components.value) {
        // Use a Set to automatically handle unique values
        const groups = new Set();
        components.value.forEach((component) => {
            if (component.groups) {
                component.groups.forEach((group) => {
                    groups.add(group);
                });
            }
        });

        // Sort the unique group names
        const sortedGroups = Array.from(groups).sort();

        // Map to the format expected by the template
        return sortedGroups.map((group) => ({
            value: group,
            text: group,
        }));
    }
    return [];
});

const fetchComponents = async () => {
    try {
        const obj = await store.dispatch('request/get', {
            url: 'api/component/themes_css',
        });
        components.value = obj.data.items;
    } catch (error) {
        console.error('Failed to fetch CSS components:', error);
    }
};

onMounted(() => {
    fetchComponents();
});
</script>

<template>
    <select
        :id="field.id"
        v-model="currentData[field.name]"
        v-form-validation
        :name="field.name"
        :required="field.required"
        class="form-select"
    >
        <option :value="''">- none -</option>
        <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
        >
            {{ option.text }}
        </option>
    </select>
</template>
